import { render, staticRenderFns } from "./RoleSettings.vue?vue&type=template&id=61fc9dba&"
import script from "./RoleSettings.vue?vue&type=script&lang=js&"
export * from "./RoleSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports